module.exports = __webpack_public_path__ + "img/20190624161149391.2e16504f.png";